export default __webpack_public_path__ + "static/media/CRLonsdaleOpen.85984c8f.jpg";